import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    fetchMe();
  }, [fetchMe]);

  const loginLocal = async (email, password) => {
    // Backend sets httpOnly `access_token` cookie; nothing to store client-side.
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const registerLocal = async (email, name, password, referral_code) => {
    const { data } = await api.post("/auth/register", { email, name, password, referral_code });
    // Cleanup any legacy referral hint; auth cookie is set server-side.
    localStorage.removeItem("fz_ref");
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout request failed; clearing session locally", e);
    }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, loginLocal, registerLocal, logout, refresh: fetchMe, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
